// extracted by extract-css-chunks-webpack-plugin
module.exports = {"permissionsList":"PermissionsEditor__permissionsList___3ztvC","permissionsEntry":"PermissionsEditor__permissionsEntry___WItIl","addPermissionIcon":"PermissionsEditor__addPermissionIcon___lphgK"};
    if(module.hot) {
      // 1778083492168
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  